import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonSquareGroup } from '@yme/atoms/button-select/ButtonSquareGroup';
import { setFilterOptions, getProductCardLabels, getProductValueByOption, } from '@yme/pdp-components/ProductCard';
import { SHAFT_LENGTH_KEY } from '@yme/selectors/index';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, } from '../constants';
import { getShaftLengthValue, buildShaftLengthList, getPossibleShaftLengthOptions, getAvailableSkuByShaftLengthValue, } from './helpers';
export function SelectShaftLength({ productFilterOptions, variantsOfProduct, }) {
    const productShaftLengthValues = useSelector(getProductValueByOption(SHAFT_LENGTH_KEY));
    const productCardLabels = useSelector(getProductCardLabels);
    const dispatch = useDispatch();
    const history = useHistory();
    const { sku, rotation, shaftLength } = productFilterOptions;
    const onSelectNewValue = useCallback((value) => {
        if (value && shaftLength !== value) {
            const currentVariant = getAvailableSkuByShaftLengthValue({
                colorVariants: variantsOfProduct,
                shaftLengthValue: value,
                rotationStateValue: rotation,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    shaftLength: currentVariant.shaftLength || value,
                    // set relative options
                    sku: currentVariant.sku,
                    rotation: currentVariant.rotation,
                    startingMethod: currentVariant.startingMethod,
                    controlMethod: currentVariant.controlMethod,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, rotation, shaftLength, sku, variantsOfProduct]);
    const isCurrentFilterExist = Boolean(productShaftLengthValues &&
        productShaftLengthValues?.some((item) => Boolean(item.trim().length)));
    if (isCurrentFilterExist) {
        const preparedShaftLengthList = buildShaftLengthList(productShaftLengthValues);
        const possibleOptions = (variantsOfProduct && getPossibleShaftLengthOptions(variantsOfProduct, rotation)) || [];
        const currentShaftLengthParams = getShaftLengthValue(preparedShaftLengthList, shaftLength);
        return (React.createElement(FlexWrapper, { mt: "24px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px", gap: "4px" },
                React.createElement(RegularTextLevel3, { as: "span", weight: 500 },
                    productCardLabels?.productCard_shaftLength_label,
                    currentShaftLengthParams?.titlePrefix && ': '),
                currentShaftLengthParams?.titlePrefix && (React.createElement(RegularTextLevel3, { as: "span", weight: 500, color: colorCoreBlack300 }, currentShaftLengthParams.titlePrefix))),
            React.createElement(FlexWrapper, { flexDirection: "row", gap: "8px", flexWrap: "wrap", minHeight: "44px" },
                React.createElement(ButtonSquareGroup, { contentTag: RegularTextLevel4, defaultContentStyles: DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, activeContentStyles: ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, setActiveOption: onSelectNewValue, allOptions: preparedShaftLengthList, possibleOptions: possibleOptions, selectedValue: shaftLength || '', dataTestId: "shaft-length" }))));
    }
    return null;
}
SelectShaftLength.displayName = 'SelectShaftLength_Component';
